import Title from "antd/es/skeleton/Title";
import i18n from "i18next";
import { initReactI18next } from "react-i18next";

const savedLanguage = localStorage.getItem("i18nextLng") || "en";

i18n.use(initReactI18next).init({
  resources: {
    en: {
      translation: {
        //Header 
        header: {
          home: "Home",
          services: "Services",
          prebooking: "Prebooking Trips",
          tripDetails: "Trip Details",
          tourism: "Tourism Tours",
          sendParcel: "Send Parcels",
          news: "News",
          aboutus: "About Us",
          contactus: "Contact Us",
          languageSwitch: "عربي",
          editProfile: "Edit Profile", // Added
          myTrips: "My Trips", // Added
          myReservation: "My Reservation", // Added
          myWallet: "My Wallet", // Added
          mySendParcel: "My Send Parcels", // Added
          myRates: "My Rates", // Added
          myPreferences: "My Preferences", // Added
          verification: "Verification", // Added
          notification: "Notification", // Added
          registerAsTraveler: "Register as a Traveler", // Added
          logout: "Logout", // Added
          Login: "Login",
        },
        //Status Map
        status:
        {
          pending: "Pending",
          confirmed: "Confirmed",
          cancelled: "Cancelled",
          completed: "Completed",
          noAnswer: "No Answer",
          unknown: "Unknown Status"
        },
        //Trip Details Page
        trip: {
          information: "Trip Information",
          sourceCity: "source city",
          destinationCity: "destination city",
          startDate: "start date",
          startTime: "start time",
          creationDate: "creation date",
          realCost: "real cost",
          passengerName: "passenger name",
          passengerPhone: "passenger phone",
          passengerCount: "passenger count",
          bagCount: "bag count",
          employeeName: "employee name",
          description: "description"
        },
        tripStatus: {
          pending: "Pending",
          confirmed: "Confirmed",
          cancelled: "Cancelled",
          completed: "Completed",
          noAnswer: "No Answer",
          unknown: "Unknown"
        },
        //Loginpage
        userLogin: {
          Heading: "Login to you account",
          phonenumber: "Phone Number*",
          passWord: "Password*",
          remeber: "Remember me",
          forget: "Forgot password?",
          loginNow: "Login Now",
          DontHave: "Don't have an account?",
          CreateNew: "Create New Account",
        },
        //Registration
        Registration: {
          createNew: "Create New Account",
          FullName: "Full Name*",
          PhoneNumber: "Phone Number*",
          Email: "Email*",
          Password: "Password*",
          DateofBirth: "Date of Birth*",
          Gender: "Gender*",
          RegisterNow: "Register Now",
          Already: "Already have an account?",
          LoginNow: "Login Now",
        },

        /////login dropdown
        dropdown: {
          //editpro
          fullname: "Full Name*",
          phone: "Phone Number*",
          email: "Email*",
          dob: "Date of Birth*",
          Gender: "Gender*",
          editprobutton: "Edit profile",

          //mytrip
          Gotrip: "Go Trip",

          //myWallet
          Walletbalance: "Wallet balance",
          Wallethistory: "Wallet history",
          Addbalance: "Add balance",
          Withdrawbalance: "Withdraw a balance",

          //myrates
          totalReview: "Total rates",
          Review: "reviews",

          //mypreffrence
          smoking: "Smoking",
          airCondistioning: "Air Conditioning",
          Music: "Music",
          chating: "Chating",
          carCharger: "Car Charger",
          suitcase: "Suitcase",
          wifi: "Wifi",
          displayScreen: "Display Screen",

          //varification
          phoneNumber: "Phone Number",
          Emailaddress: "Email-address",
          IDcard: "ID card",
        },

        //Home Page
        heroSection: {
          heroTitle:
            "Rehla App is The Best App For Booking Ride And Sharing Trips",
          heroDescription:
            "Rehla is a ride sharing and a ride hailing service that links between passengers and vehicle owners heading to the same destination.",

          AboutReh: "About Rehla",
          Rehla: "Rehla",
          RehlaIntro: "introducing video promotion",
          RehDes:
            "Rehla application .... the pleasure of traveling between cities at the lowest cost and more safety Rehlacar offers a unique travel experience between cities at the lowest cost and the most enjoyable and safe ways. Rehla application licensed by the Public Transport Authority and compatible with all safety and security requirements in Saudi Arabia, and is based on the principle of sharing travel costs between passengers and vehicles owners .",

          startTrip: "Start Your ride Now",
          offerUp: "Offer up to 30% for each ride",

          Signup: "Sign up ",
          addingcar: "in Rehla and adding car",
          Trainingvideo:
            "Training video explaining how to create an account in Rehla, fill in the registration data, and view the login method if you already have an account in Rehla. How to register your car information to be reviewed and registered in Rehla application as a captain, as you can know your balance through the wallet.Watch",

          Create: "Create and ordering a trip",
          explanation:
            "explanation of how to use Rehla app How to create a ride-sharing trip by the captain and search for them by the passenger, and the possibility of requesting a prior reservation for the ride-sharing trip, How to request a ride-hailing trip inside the city and how to receive the request by Rehla captains.",

          join: "Join tourism experts as a",
          Traveler: "Traveler",
          Rehla: "Rehla",

          firstStep: "First Step",
          secondStep: "Second Step",
          thirdStep: "Third Step",

          first:
            "Please Click on the Join Now and fill in your data as a tourist traveler",
          second: "Fill out your tourism information form",
          third: "After reviewing our data, you will be able to create tours",

          book: "Book your prebooking",
          trip: "trip now",
          login:
            "Login with your account for Rehla or create an account for the first time through our website or App",
          goto: "Go to Prebooking Trips",
          select:
            "Select your destination and departure date and book now and wait for your offer to be accepted by one of our captains",

          Featuredcoures: "Featured coures",
          Charge: "Charge Cards Now",
          price: "Price",
          Chargewallet: "Charge wallet",

          screenShot: "screenshots",
          screenshotDesc: "Explore Rehla's user-friendly interface and discover how easy it is to book rides, manage trips, and travel smarter.",

          clentSay: "What clients are saying",
        },
        rehlaServiceSection: {
          rehlaServiceTitle: "Rehla",
          rehlaSer: "Services",
          rehlaServiceDescriptions:
            "Fully layered dolor sit amet, nobis id expedita dolores officiis laboriosam",
          serviceTitle1: "Ride Hailing",
          serviceDescription1:
            "Passengers can request a ride with a nearby driver to reach their destination quickly and safely within the city.",
          serviceTitle2: "Prebooking trips",
          serviceDescription2:
            "Plan ahead by booking trips in advance. Choose your destination and travel date, then wait for a captain to accept your request.",
          serviceTitle3: "Tourism Tours",
          serviceDescription3:
            "Tourism experts can create customized tours for tourist destinations. Travelers can browse tours by region and book unique travel experiences.",
          serviceTitle4: "Sending Parcels",
          serviceDescription4:
            "Send parcels between cities easily. Post your delivery request and wait for a Rehla captain to accept and deliver your package securely.",
        },

        //Pre-BookingTrips page
        preBookingtrips: {
          startPlace: "Start Place",
          arrivalPlace: "Arrival Place",
          startDate: "Start Date",
          startTime: "Start Time",
          paymentType: "Payment Type",
          SelectCarcategory: "Select Car Category",
          EmployeeName: "Name of Employee",
          PassengerName: "Passenger Name",
          PassengerPhone: "Passenger Phone",
          BagCount: "Number of Bags",
          PassengerCount: "Number of Passengers",
          coupon: "Coupon",
          Description: "Notes",
          preBookingNow: "Prebooking Now",
          Cash: "Cash",
        },

        //BookTour page
        bookTour: {
          startFrom: "Start Place",
          startDate: "Start Date",
          paymentType: "Payment Type",
        },

        //TourismTour Page
        tourismTour: {
          tourismTitle: "Tourism Tours",
          tourismTitleErr: "Tourism Tours Currently Unavailable",
          tourismTitleErr2: "We are currently working on developing and enhancing our Tourism Tours service to deliver a high-quality experience.",
          tourismTitleErr3: "The service will be available soon. Stay tuned for updates.",
          rehlaTourism: "Rehla",
        },

        sendParcel: {
          SourceCity: "Sender location",
          DestinationCity: "Receiver location",
          SenderPhone: "Sender phone",
          SenderName: "Sender name",
          SenderId: "Sender ID",
          ReceiverPhone: "Receiver phone",
          ReceiverName: "Receiver name",
          ReceiverId: "Receiver ID",
          Notes: "Notes",
          sendParcelNow: "Send Parcel",
        },

        //AboutUs Page
        AboutUspage: {
          stayTuned: "Stay tuned for new newsThey are coming with offer",
          featureIntegration: "Feature Integration",
          multipleDiscussions: "Multiple Discussions",
          GetStarted: "Get Started",

          OurRehla1: "Our",
          OurRehla2: "Rehla",
          OurRehla3: "Team",

          Gallery: "Gallery",

          SeeAll: "See All",
          Branding: "Branding",
          Designing: "Designing",
          Photography: "Photography",
          Development: "Development",

          availablDevices: "Rehla is available for all devices",
          avaiDes:
            "Enjoy smart, affordable, and safe travel across cities",
        },

        //ContactUsPage
        contactUspage: {
          nameplaceholder: "Enter Your Name",
          emailplaceholder: "Enter Your Email Address",
          messageplaceholder: "Write Your Message",
          submit: "Send Message",
        },

        //Footer page
        footer: {
          description1: "Rehla is a ride sharing and a ride hailing ",
          description2: "service that links between passengers",
          description3: "and vehicle owners heading to",
          description4: "the same destination",
          sitemap: "Site map",
          usefulLinks: "Useful links",
          contactInfo: "Contact Info",
          address1: "Itqan Square, Madinah Road- P.O 23215",
          address2: "Kingdom of Saudi Arabia",
          phone: "920011455",
          email: "care@rehlacar.com",
          home: "Home",
          services: "Services",
          prebooking: "Prebooking Trips",
          tourism: "Tourism Tours",
          sendParcel: "Send Parcels",
          news: "News",
          terms: "Terms of Use",
          privacy: "Privacy Policy",
          faq: "Frequently Asked",
          copyright: "All Rights Reserved",
        },
        //Terms of Use Page
        termsOfUse: {
          terms: "Terms and Conditions",

          Title1: "Introduction",
          Discription1: "Please read these Terms and Conditions carefully before using the Rehla application or any of its services.",
          List1: [
            "By completing the registration process or continuing to use the application, you explicitly agree to comply with these Terms and Conditions, which grant you a limited license to use the application and its services.",
            "This license is granted for personal use only and does not permit you to sell, distribute, or exploit the application or any of its features or technologies.",
            "If you do not agree to any of these Terms and Conditions, you must refrain from using the application or any of its services.",
            "Your acceptance of these Terms constitutes a legally binding agreement between you and Rehla regarding your use of the services.",
            "Rehla reserves the right to suspend or terminate services or restrict access to the application or any part thereof at any time and for any reason without prior notice.",
            "Rehla reserves the right to amend these Terms and Conditions from time to time, and such amendments shall become effective upon publication within the application.",
            "Rehla may disclose certain information, including your contact details, to relevant authorities or insurance companies when necessary to resolve disputes or claims.",
            "This includes situations involving disputes or incidents between you and a third-party service provider, where such information is required to resolve the matter."
          ],

          Title2: "Definitions",
          Discription2: "All terms mentioned in these Terms and Conditions shall have the meanings assigned to them below:",
          List2: [
            "Rehla Land Transport Company (\"we\", \"us\", \"our\"): Refers to the Rehla application and is committed to protecting and respecting privacy.",
            "Account: Refers to the user's account on the Rehla mobile application that enables access to the app.",
            "Application: Refers to the Rehla mobile application and any updates released from time to time.",
            "Registration Data: Includes name, phone number, email, age, and any other information requested during or after registration.",
            "User: Any person who has created an account to use the application. \"You\" refers to the user.",
            "Trip Price: The proposed price for the transport service, which the service provider authorizes the Rehla app to determine.",
            "Rehla Application: Includes both the mobile application and the web platform.",
            "Working Days: Official working days from Sunday to Thursday.",
            "Balance: The stored value in the user's wallet within the application, which can be used to pay for bookings.",
            "Service Provider: The driver, carrier, or tour guide providing the transport service.",
            "Service Requester: The passenger, traveler, tourist, or parcel sender who makes a booking confirmed by the service provider.",
            "Damage: Includes bodily injury, loss, partial loss, death, theft, or any other harm to the passenger.",
            "Departure Location: The location specified by the user as the starting point of the trip.",
            "Arrival Location (Destination): The location specified by the user as the end point of the trip.",
            "Departure Time: The time specified by the user for the trip to begin."
          ],

          Title3: "License",
          Discription3: "Your acceptance of these Terms and Conditions constitutes a formal commitment between you and the Rehla application.",
          List3: [
            "Accordingly, Rehla grants you, upon compliance with these Terms, a limited, non-exclusive license that is non-sublicensable and non-transferable to any third party.",
            "This license is granted for the purpose of accessing and using the Rehla application on your personal device.",
            "And to access and use any content, information, or related materials made available through the Rehla application.",
            "In all cases, the use of the Rehla application shall be strictly personal and non-commercial.",
            "Rehla and its licensors reserve all rights not expressly stated in these Terms of Use."
          ],
          Title4: "Intellectual Property Rights",
          Discription4: "",
          List4: [
            "All ownership rights of the Rehla application belong to Tarhal Al-Modon Land Transport Establishment and those operating it on its behalf.",
            "All visual interfaces, graphics, designs, information, content, computer code of the website, used software, services, and all other elements of the application, as well as all intellectual property rights and ownership rights related to these elements, are exclusively owned by the Rehla application or its licensors.",
            "All trademarks, service marks, and trade names are owned by Rehla, its affiliates, partners in providing travel services, or other providers.",
            "Nothing in this agreement or your use of the Rehla platform grants you any rights in or related to the platform except for the license granted under this agreement.",
            "You may not use or refer in any way to the names of the Rehla application, its logos, product names, services, trademarks, service marks, or the names of its licensors."
          ],
          Title5: "Trust and Credibility",
          Discription5: "",
          List5: [
            "This application provides trust and credibility as it complies with all documents and requirements imposed by the Ministry of Transport or Elm platform through a taxi booking and distribution system integrated with the General Transport Authority system (Wasl platform), ensuring verification similar to other applications and providing full trip details such as vehicle route, driver name, and plate number.",
            "Trust and credibility increase with higher ratings and feedback from passengers and vehicle owners, giving an impression that the person you deal with is trustworthy and safe.",
            "In case of any complaint or report, it is verified using the registered communication methods, followed by appropriate action. Maximum effort is also made to recover any lost items."
          ],
          Title6: "User Accounts",
          Discription6: "",
          List6: [
            "This application acts as an intermediary between service providers and service requesters.",
            "To use most Rehla services, you must register and maintain an active personal account.",
            "You confirm that you are at least 18 years old and not older than 65 years old to be eligible for an account.",
            "Account registration requires providing personal information such as your name, address, mobile number, gender, age, and national ID number.",
            "You agree to provide accurate, complete, and up-to-date information and maintain it.",
            "Failure to maintain accurate information may result in inability to access or use the platform, including accessing your personal data or requesting or creating trips.",
            "You are responsible for all activities conducted under your account and must maintain the security and confidentiality of your username and password at all times.",
            "By agreeing to these terms, you allow the application to share some of your information with other users through your public profile or during booking (e.g., ratings, reviews, and your phone number for easier communication).",
            "For passengers (service requesters), you acknowledge that the application operates as an intermediary connecting drivers and customers, providing services such as airport transfers, guided tours, parcel delivery, and intercity travel.",
            "You agree to pay the full trip fare set by the application to the service provider (captain).",
            "As part of our rating system, your reviews, ratings, short name, and profile image may be displayed publicly.",
            "If you are a competitor or provide competing services and register on the platform, your acceptance of these terms is considered void, and you are not allowed to continue using the application. Legal action may be taken against unauthorized or unlawful use.",
            "You may not own more than one account unless permitted by Rehla.",
            "You confirm that your account has not been previously suspended or restricted for reasons preventing you from using the platform."
          ],
          Title7: "User Representations, Warranties, and Conduct",
          Discription7: "By agreeing to these Terms and Conditions, you acknowledge and undertake to comply with all regulations and laws imposed by official authorities in the Kingdom of Saudi Arabia, such as the Transport General Authority. The user must be at least 18 years old and not exceed 65 years old for service providers. The service must only be used by legally qualified adults. You may not allow others to use your account, nor assign or transfer your account to another person or entity. You agree to comply with all applicable laws while using the Rehla application, and you may only use the application for lawful purposes. Copying content or capturing internal screenshots for unauthorized use is prohibited.",

          Title8: "Registration and Application Usage",
          Discription8: "Using this application requires registration for vehicle owners (captains), vehicles, and passengers who meet the basic requirements for subscribing to the service according to the requirements of the Transport General Authority, which requires integration with the approved technical system of the Transport Authority (Wasl Platform). Registration requirements are divided into the following sections:",

          Title8_1: "First: Captain (Vehicle Owner – Service Provider)",
          Discription8_1: "A person who owns a vehicle and wishes to operate it through applications licensed by the Transport Authority without being bound to a specific schedule. They receive trip requests from passengers in exchange for a financial amount and must comply with the following regulatory requirements:",
          List8_1: [
            "Must be a Saudi national or the son/daughter of a Saudi citizen.",
            "Must hold a valid driving license.",
            "Must pass the medical examination specified by the authority.",
            "Must obtain a certificate of no criminal record.",
            "Must complete the training course related to using the application.",
            "Must have a valid driving license.",
            "Must be the actual driver of the vehicle or authorized to drive it.",
            "Must own a smartphone with the application installed and an active local number with internet access.",
            "Must be between 18 and 65 years old."
          ],

          Title8_2: "Second: Vehicle",
          Discription8_2: "The vehicle used in this application must meet certain requirements and specifications set by the official authorities in the Kingdom of Saudi Arabia:",
          List8_2: [
            "The vehicle must comply with the approved technical specifications and equipment.",
            "The vehicle must be insured to cover civil liability toward third parties including passengers during operation.",
            "The vehicle must undergo the approved periodic technical inspection according to traffic regulations.",
            "The vehicle must be owned directly by the driver or financed through an approved financing entity.",
            "A valid vehicle registration must show ownership or authorized driving for leased vehicles.",
            "The operational age must not exceed five years from January of the manufacturing year.",
            "The wheelbase must not be less than 2.75m except for electric and hybrid vehicles.",
            "The vehicle must be in good condition and free of visible damage, branding, or advertisements.",
            "The vehicle must contain: a spare tire, first aid kit, fire extinguisher, reflective triangle, and necessary tools for changing tires in good condition.",
            "Vehicle tinting is not permitted before approval for service entry or during operation."
          ],

          Title8_3: "Third: Service Requester",
          Discription8_3: "A person who wishes to travel from one place to another or between cities. To register as a customer in the Rehla application, the following requirements must be met:",
          List8_3: [
            "A communication phone device.",
            "A valid national ID or residency permit.",
            "A smartphone with the application installed and internet connectivity."
          ],

          Title9: "Pricing, Fees, Payments, and Taxes",
          Discription9: "As a service provider on the Rehla application, you agree to authorize Rehla to determine the price and to pay any amounts due from your account for benefiting from the mediation service provided through the application. If there is insufficient balance, the wallet may go negative (minimum debt threshold) before the account is suspended. All fees and expenses related to the use of the Rehla platform are due immediately and payments will be facilitated through available payment methods in the application (wallet top-up). Rehla reserves the right to impose, cancel, or modify fees at any time at its sole discretion.",

          Title10: "Payment Settlement, Pricing Mechanism, and Cost Calculation",
          Discription10: "By agreeing to these Terms and Conditions as a service provider or requester, you agree that the Rehla application may suggest a trip price based on the data provided by the service requester (distance in kilometers from pickup to destination, trip duration, waiting time, peak time, vehicle category, base fare, Transport Authority fee of 0.50 SAR, and VAT). The service requester has full freedom to accept or reject the displayed trip price.",

          Title10_1: "1- Mediation Service Fee",
          Discription10_1: "A mediation service fee (application commission) is deducted from the service provider’s (Captain’s) wallet as a percentage of the trip fare in exchange for using the application and providing mediation between service providers and service requesters to complete the booking process, ensure the safety and reliability of reservations, complete booking procedures, and facilitate payment transfers through the application.",

          Title10_2: "2- Government Cost",
          Discription10_2: "According to the requirements of the Transport General Authority regarding integration with the Wasl platform and providing its services, an amount of 0.50 SAR (fifty halalas) is collected as a service cost fee under the agreement with the Wasl platform for any trip created through the application. This amount is included within the operational costs of the Rehla application.",

          Title10_3: "3- Value Added Tax (VAT)",
          Discription10_3: "In accordance with the Value Added Tax regulations applicable in the Kingdom of Saudi Arabia, the mediation service is considered a taxable activity subject to the standard VAT rate of 15%. VAT is applied to the commission value of the Rehla application.",

          Title11: "Payment Mechanism, Wallet Withdrawal, Compensation, and Refund Policy",

          Discription11: "The application provides multiple payment methods to meet the needs of both the service requester and the service provider, while considering security, credibility, and data protection standards. Financial transactions are primarily conducted through the electronic wallet, which is used to manage trip payments and deduct due amounts. The wallet balance reflects the available monetary value, with a detailed transaction history documenting all operations, where the due amount is deducted upon booking completion. The application allows service providers (drivers) to withdraw their earnings at any time by submitting a withdrawal request through the wallet. Withdrawal requests are processed in four batches daily with no associated fees. The transfer process takes up to 3 business days, provided the minimum withdrawal amount is 50 SAR. If the wallet is charged and then withdrawn without any usage (such as booking a trip), refunds will be processed to the same payment method used, subject to applicable bank fees or charges. Refunds may take up to 15 business days from the request date.",

          PaymentMethodsTitle: "Available Payment Methods:",

          List11_1: [
            "Direct cash payment from the service requester to the service provider.",
            "Wallet top-up using prepaid application cards.",
            "Bank transfer or Visa card for wallet top-up.",
            "Depositing into the application account and receiving a recharge code via mobile.",
            "Using promotional offers to top up the wallet."
          ],

          Title12: "Booking Conditions",
          Discription12: "When a traveler makes any booking, they confirm on their own behalf and on behalf of those accompanying them that they have read these booking conditions, agree to comply with them, and have the authority to do so. They also agree to our use of their information in accordance with our Privacy Policy. The traveler must accept all conditions before completing the payment process for the booking to be confirmed. All travelers must be fully aware of and understand the conditions during the booking process. A booking will not be successfully completed unless the full amount is paid through the wallet, except in the case of selecting cash payment.",

          Title13_1: "If the trip is cancelled or the Captain is late to arrive",
          List13_1: [
            "The service requester shall receive a full refund of the paid amount if the trip is cancelled by the service provider before the scheduled time, provided that the requester attempts to contact the provider to confirm the lack of response and reports it through the application within 24 hours.",
            "The service requester shall receive a full refund if the vehicle breaks down during the trip by the service provider, either directly or by depositing the amount into the requester’s wallet."
          ],

          Title13_2: "If the trip is cancelled or the passenger is late to arrive",
          List13_2: [
            "Cancellation more than 12 hours before the scheduled departure time: the service requester is entitled to a full refund of the trip cost if the payment was made through the wallet.",
            "Cancellation within 12 hours but more than 3 hours before departure: the service requester bears half of the trip cost, and the remaining amount is transferred to the service provider’s wallet.",
            "Cancellation 3 hours or less before departure, or failure to arrive at the pickup location within 15 minutes: no refund will be issued to the service requester and the service provider is entitled to the full fare.",
            "Cancellation after the service provider arrives due to mismatched information in the application compared to the vehicle or driver: the passenger will be compensated for the trip cost and a penalty will be applied to the service provider’s account.",
            "Cancellation due to the vehicle not being clean, with valid proof: a replacement vehicle will be sent to the passenger.",
            "Cancellation in case the trip is delayed beyond the scheduled time in the application: the service requester will be compensated with half of the trip cost."
          ],

          Title13_3: "If the Rehla application cancels your booking",
          List13_3: [
            "We may cancel your booking at any time with immediate effect if you violate any fundamental terms or fail to settle all required payments in the wallet within the specified time.",
            "In exceptional circumstances, we may cancel your booking due to force majeure, a service provider becoming unavailable, or to perform updates or modifications to the application."
          ],

          Title14: "Monitoring Mechanism for Service Providers and Vehicles",
          List14: [
            "When registering as a service provider, you must submit official documents such as a national ID, a valid driving license, the vehicle registration form, a valid periodic inspection certificate, and any other documents required to complete the registration.",
            "Vehicle eligibility is verified by inspecting the vehicle through an authorized inspection company or by submitting video clips or photos proving the vehicle’s condition and safety.",
            "The Rehla application conducts periodic random inspections to evaluate vehicle cleanliness and ensure that the registered drivers themselves are performing the trips, while also taking into account customer ratings and feedback.",
            "Vehicles operating in airports and train stations may be verified by customer service supervisors (dispatchers) present at those locations.",
            "Any regulations issued by the Transport Authority regarding this matter will be taken into consideration."
          ],


          Title15: "Repair or Cleaning Expenses",
          Discription15: "The Rehla application and passengers shall not bear any expenses related to repair or cleaning resulting from dust, dirt, or mechanical issues affecting the vehicle. The vehicle must always be clean and in good condition to avoid negatively affecting the rating of the vehicle or the Captain.",

          Title16: "Prohibited Activities",
          Discription16: "In relation to your use of the Rehla platform and participation in its services, you agree to avoid engaging in the following prohibited activities. If any of these are proven, you will bear full responsibility for complying with all applicable laws and regulations, and your account may be suspended, banned, or subject to legal action:",

          Title17: "Disabilities and Medical Conditions",
          Discription17: "If you or any member of your group suffers from a medical condition or disability that may affect your trip, please inform the Captain when making the booking in the section titled (Talk about yourself). In all cases, you must provide complete written details at the time of booking. The Captain has the right to accept or reject the booking and assumes the consequences of acceptance once informed of these details.",

          Title18: "Disclaimer",
          Discription18: "The Rehla platform is provided as currently available. Rehla disclaims all representations and warranties, whether express, implied, or statutory, including implied warranties of merchantability and fitness for a particular purpose. Rehla and its affiliates do not guarantee the quality, suitability, safety, or ability of any driver. Rehla and its affiliates are not responsible for the conduct of any user, driver, or third party. The vehicle owner alone is responsible for compensating any damages that may occur to others during or as a result of providing the service. We are not required to provide insurance for personal belongings, including loss of personal luggage due to theft or being forgotten in the vehicle.",

          Title19: "Limitation of Liability",
          Discription19: "Rehla, its affiliates, and partners shall not be liable for any indirect, incidental, special, consequential, exemplary, or punitive damages, including lost profits, lost data, or personal injuries. Rehla shall not be responsible for any damages, liabilities, or losses arising from:",

          Title20: "Indemnification",
          Discription20: "In the event of any injuries, illnesses, deaths, losses, damages, expenses, costs, or other claims of any kind, we shall not bear any liability nor provide any compensation as our role is limited to mediation between the traveler and the Captain. You agree to indemnify and hold harmless the Rehla platform, its affiliates, partners, employees, directors, officers, and agents from and against any claims, demands, losses, liabilities, or expenses, including legal fees, arising out of your use of the Rehla platform or your violation of this agreement.",

          Title21: "Dispute Resolution and General Provisions",
          Discription21: "You may not assign or transfer your rights under this agreement, in whole or in part, without obtaining prior written consent from the Rehla platform. This agreement constitutes the entire agreement and understanding between the parties regarding its subject matter and supersedes all prior or existing agreements or undertakings related to this subject. The agreement between you and Rehla does not create any joint venture, partnership, employment, or agency relationship between you and Rehla or any driver.",

          Title22: "Amendments to Terms and Conditions and Bookings",
          Discription22: "The Rehla application reserves the right to modify or add any terms from time to time at any moment without prior notice. Any new version or update of the Terms and Conditions will be published on the platform and application. By downloading the update or new version and continuing to use the application after such modifications, you automatically agree to and accept these amendments or changes.",

          Title23: "Complaints",
          Discription23: "If you wish to submit any complaint or inquiry, please contact us directly through the link designated for complaints and inquiries within the application (Contact Us). Multiple communication channels are available to customers according to their needs, including a lost-and-found service through which we strive to make every effort to help you recover lost items and facilitate a secure and easy return process. Complaint procedures are handled within three business days.",

          Title24: "Language",
          Discription24: "This application adopts Arabic as the primary language for use and interpretation, in addition to English for usability purposes. Additional languages may be added to the application in the future based on needs.",
          Title25: "Violations and Penalties Regulation",
          Discription25: "The Rehla platform applies an approved Violations and Penalties Regulation to regulate the use of the platform and ensure compliance with applicable laws and regulations. You can review the full regulation by",
          DownloadViolations: "download the Violations and Penalties Regulation (PDF)"
        },
        // Privacy Policy Page
        privacy: {
          Title1: "Privacy Policy",
          Discription1: "At Rehla App, owned by Tarhal Al-Mudun Land Transport Company, we are committed to protecting our users’ privacy and safeguarding their personal data. This policy explains how we collect, use, share, and protect information when you use the app or any of its services.",

          Title2: "Information We Collect",
          Discription2: "When you register and use the Rehla app, we may collect certain personal data, including your name, phone number, email address, age, national ID or residency number, location data, trip and booking details, and any other information required to provide the service.",

          Title3: "How We Use Information",
          Discription3: "We use the collected information to operate and improve Rehla services, manage user accounts, process bookings, communicate with users, handle payments, enhance user experience, and comply with applicable laws and regulations in the Kingdom of Saudi Arabia.",

          Title4: "Sharing Information with Third Parties",
          Discription4: "We may share certain user data with official or regulatory authorities such as the Transport General Authority, relevant government entities, insurance companies, or service providers when legally required or for resolving complaints, disputes, or incidents related to app usage.",

          Title5: "Data Protection and Security",
          Discription5: "We implement appropriate technical and organizational measures to protect personal data from unauthorized access, alteration, disclosure, or destruction, and we regularly update our security systems to maintain a high level of protection.",

          Title6: "Data Retention",
          Discription6: "We retain personal data only for as long as necessary to fulfill the purposes outlined in this policy, comply with legal obligations, resolve disputes, and enforce agreements.",

          Title7: "User Rights",
          Discription7: "Users have the right to access, update, or request correction of their personal data, as well as request account deactivation in accordance with applicable regulations. Identity verification may be required to process certain requests.",

          Title8: "Location Data",
          Discription8: "Rehla may use location and usage data to improve service accuracy and user experience. Such data is used strictly for operational purposes.",

          Title9: "Privacy Policy Updates",
          Discription9: "Rehla reserves the right to modify or update this Privacy Policy from time to time. Updates will be published on the app or website, and continued use of the services constitutes acceptance of the updated policy.",

          Title10: "Contact Us",
          Discription10: "If you have any questions or requests regarding this Privacy Policy or your personal data, please contact us at Care@rehlacar.com or through the in-app support channels.",
          Title11: "Account & Data Deletion",
          Discription11: "If you wish to delete your account and all related data from our database, please click ",
          DeleteLink: "here",
          enterPhone: "Please enter your phone number",
          enterOtp: "Please enter the code sent to your phone",
          next: "Next",
          confirm: "Confirm",
          deleteSuccess: "Your account has been successfully deleted.",
          loading: "Please wait...",
          phonePlaceholder: "512345678",
          phoneNotFound: "The entered phone number was not found",
          somethingWrong: "Something went wrong, please try again",
          deleteAccountDescription: "To delete your account, enter the phone number associated with it. A verification code will be sent to confirm your identity. After verification, your account and all related data will be permanently deleted.",
        },
      },
    },

    ///////////////urdu translations
    ur: {
      translation: {
        header: {
          home: "الرئيسية",
          services: "خدمات",
          prebooking: "الحجز المسبق",
          tripDetails: "تاصيل الرحلة",
          tourism: "جولات سياحية",
          sendParcel: "إرسال الطرود",
          news: "أخبار",
          aboutus: "من نحن؟",
          contactus: "اتصل بنا",
          languageSwitch: "عربي",
          editProfile: "تحرير الملف الشخصي", // Added
          myTrips: "رحلاتي", // Added
          myReservation: "حجوزاتي", // Added
          myWallet: "محفظتي", // Added
          mySendParcel: "الطرود المرسلة", // Added
          myRates: "تقييماتي", // Added
          myPreferences: "تفضيلاتي", // Added
          verification: "تَحَقّق", // Added
          notification: "إشعار", // Added
          registerAsTraveler: "سجل كمسافر", // Added
          logout: "تسجيل الخروج",
          Login: "تسجيل الدخول",
        },
        //trip
        trip: {
          information: "معلومات الرحلة",
          sourceCity: "مدينة المصدر",
          destinationCity: "مدينة الوصول",
          startDate: "تاريخ البداية",
          startTime: "وقت البداية",
          creationDate: "تاريخ الإنشاء",
          realCost: "التكلفة الفعلية",
          passengerName: "اسم الراكب",
          passengerPhone: "هاتف الراكب",
          passengerCount: "عدد الركاب",
          bagCount: "عدد الحقائب",
          employeeName: "اسم الموظف",
          description: "الوصف"
        },
        tripStatus: {
          pending: "قيد الانتظار",
          confirmed: "مؤكد",
          cancelled: "ألغيت",
          completed: "اكتملت",
          noAnswer: "لا يوجد رد",
          unknown: "غير معروف"
        },
        //Status Map
        status: {
          pending: "قيد الانتظار",
          confirmed: "مؤكدة",
          cancelled: "ملغاة",
          completed: "مكتملة",
          noAnswer: "لا يوجد رد",
          unknown: "حالة غير معروفة"
        },

        //Loginpage
        userLogin: {
          Heading: "تسجيل الدخول إلى حسابك",
          phonenumber: "رقم التليفون",
          passWord: "كلمة المرور",
          remeber: "تذكرنى",
          forget: "هل نسيت كلمة السر؟",
          loginNow: "تسجيل الدخول الآن",
          DontHave: "ليس لديك حساب؟",
          CreateNew: "إنشاء حساب جديد",
        },

        //Registration
        Registration: {
          createNew: "إنشاء حساب جديد",
          FullName: "الاسم الكامل",
          PhoneNumber: "رقم التليفون",
          Email: "بريد إلكتروني",
          Password: "كلمة المرور",
          DateofBirth: "تاريخ الميلاد",
          Gender: "جنس",
          RegisterNow: "سجل الآن",
          Already: "هل لديك حساب بالفعل؟",
          LoginNow: "تسجيل الدخول الآن",
        },

        /////login dropdown
        dropdown: {
          //editpro
          fullname: "الاسم الكامل*",
          phone: "رقم التليفون*",
          email: "بريد إلكتروني*",
          dob: "تاريخ الميلاد*",
          Gender: "جنس*",
          editprobutton: "تحرير الملف الشخصي",

          //myTrip
          Gotrip: "اذهب للرحلة",

          //myWallet
          Walletbalance: "رصيد المحفظة",
          Wallethistory: "تاريخ المحفظة",
          Addbalance: "إضافة الرصيد",
          Withdrawbalance: "سحب الرصيد",

          //myrates
          totalReview: "إجمالي الأسعار",
          Review: "المراجعات",

          //mypreffrence
          smoking: "تدخين",
          airCondistioning: "تكييف الهواء",
          Music: "موسيقى",
          chating: "الدردشة",
          carCharger: "شاحن سيارة",
          suitcase: "حقيبة",
          wifi: "واي فاي",
          displayScreen: "شاشة العرض",

          //varification
          phoneNumber: "رقم التليفون",
          Emailaddress: "عنوان البريد الإلكتروني",
          IDcard: "بطاقة الهوية",
        },

        //home
        heroSection: {
          heroTitle: "تطبيق رحلة أفضل تطبيق لحجز الرحلات ومشاركة الرحلات",
          heroDescription:
            "رحلة هي خدمة مشاركة الرحلات وخدمة نقل الركاب التي تربط بين الركاب وأصحاب المركبات المتجهين إلى نفس الوجهة",

          AboutReh: "حول رحلة",
          Rehla: "رحلة",
          RehlaIntro: "تعريف",
          RehDes:
            "تطبيق رحلة .... متعة السفر بين المدن بأقل تكلفة وأمان أكثر يقدم موقع رحلة تجربة سفر فريدة بين المدن بأقل تكلفة وبأكثر الطرق متعة وأمان. تطبيق رحلة مرخص من هيئة النقل العام ومتوافق مع كافة متطلبات السلامة والأمن في المملكة العربية السعودية، ويقوم على مبدأ تقاسم تكاليف السفر بين الركاب وأصحاب المركبات.",
          startTrip: "ابدأ رحلتك الآن",
          offerUp: "عرض يصل إلى 30% لكل رحلة",

          Signup: "اشتراك",
          addingcar: "في رحلة وإضافة سيارة",
          Trainingvideo:
            "فيديو تدريبي يشرح كيفية إنشاء حساب في رحلة، وتعبئة بيانات التسجيل، وعرض طريقة تسجيل الدخول إذا كان لديك حساب في رحلة بالفعل. كيفية تسجيل معلومات سيارتك لمراجعتها وتسجيلها في تطبيق رحلة ككابتن، كما يمكنك معرفة رصيدك من خلال المحفظة.شاهد",

          Create: "إنشاء وطلب رحلة",
          explanation:
            "شرح كيفية استخدام تطبيق رحلة، كيفية إنشاء رحلة مشاركة من قبل الكابتن والبحث عنها من قبل الراكب، وإمكانية طلب حجز مسبق لرحلة المشاركة، كيفية طلب رحلة مشاركة من الداخل المدينة وكيفية استقبال الطلب من قبل رحلة الكباتن.",

          join: "انضم إلى خبراء السياحة ك",
          Traveler: "مسافر",
          Rehla: " رحلة ", //////////////////pen

          firstStep: "الخطوة الأولى",
          secondStep: "الخطوة الثانية",
          thirdStep: "الخطوة الثالثة",

          first: "من فضلك اضغط على انضم الآن واملأ بياناتك كسائح",
          second: "املأ نموذج المعلومات السياحية الخاص بك",
          third: "بعد مراجعة بياناتنا، ستتمكن من إنشاء جولات",

          book: "احجز حجزك المسبق في",
          trip: "رحلة الآن",
          login:
            "قم بتسجيل الدخول بحسابك الخاص برحلة أو قم بإنشاء حساب لأول مرة عبر موقعنا أو تطبيقنا",
          goto: "اذهب إلى الحجز المسبق للرحلات",
          select:
            "حدد وجهتك وتاريخ المغادرة واحجز الآن وانتظر حتى يتم قبول عرضك من قبل أحد الكباتن لدينا",

          Featuredcoures: "شحن المحفظة",
          Charge: "اشحن محفظتك عن طريق بطاقات رحلة الآن",
          price: "سعر",
          Chargewallet: "شحن المحفظة",

          screenShot: "لقطات الشاشة لتطبيق",
          screenshotDesc: "استكشف واجهة رحلة سهلة الاستخدام وتعرّف على مدى سهولة حجز الرحلات، إدارة المشاوير، والسفر بذكاء أكثر.",

          clentSay: "ما يقوله العملاء",
        },
        rehlaServiceSection: {
          rehlaServiceTitle: "رحلة",
          rehlaSer: "خدمات",
          rehlaServiceDescriptions:
            "آلام الجلوس ذات الطبقات الكاملة، nobis id expedita dolores officiis Laboriosam",
          serviceTitle1: "التنقل داخل المدينة",
          serviceDescription1:
            "يمكن للركّاب طلب مشوار مع أقرب كابتن للوصول إلى وجهتهم داخل المدينة بسرعة وسهولة وبأعلى معايير السلامة.",
          serviceTitle2: "رحلات الحجز المسبق",
          serviceDescription2:
            "خطّط رحلتك مسبقًا عبر حجز المشوار قبل موعده. اختر وجهتك وتاريخ السفر وانتظر قبول الطلب من أحد كباتن رحلة.",
          serviceTitle3: "جولات سياحية",
          serviceDescription3:
            "يتيح تطبيق رحلة للخبراء السياحيين إنشاء جولات مخصّصة للمدن والمناطق السياحية، مع إمكانية استعراض الجولات حسب المنطقة وحجز تجارب سفر مميّزة.",
          serviceTitle4: "إرسال الطرود",
          serviceDescription4:
            "أرسل الطرود بين المدن بكل سهولة. قدّم طلب التوصيل وانتظر قبول المهمة من أحد كباتن رحلة لتصل شحنتك بأمان.",

          AboutReh: "ریحلا کے بارے میں",
          Rehla: "ریحلہ",
          RehlaIntro: "ویڈیو پروموشن کا تعارف",
          RehDes:
            "ریہلا ایپلی کیشن .... شہروں کے درمیان سب سے کم قیمت پر سفر کرنے کی خوشی اور زیادہ حفاظت Rehlacar سب سے کم قیمت پر شہروں کے درمیان سفر کا ایک انوکھا تجربہ پیش کرتا ہے اور انتہائی پرلطف اور محفوظ طریقے۔ Rehla ایپلیکیشن پبلک ٹرانسپورٹ اتھارٹی کی طرف سے لائسنس یافتہ ہے اور سعودی عرب میں تمام حفاظتی اور حفاظتی تقاضوں سے ہم آہنگ ہے، اور مسافروں اور گاڑیوں کے مالکان کے درمیان سفری اخراجات بانٹنے کے اصول پر مبنی ہے۔",
        },

        //Pre-BookingTrips page
        preBookingtrips: {
          startPlace: "مكان البدء",
          arrivalPlace: "مكان الوصول",
          startDate: "تاريخ البدء",
          startTime: "وقت البدء",
          paymentType: "نوع الدفع",
          SelectCarcategory: "اختر فئة السيارة",
          EmployeeName: "اسم الموظف",
          PassengerName: "اسم الراكب",
          PassengerPhone: "هاتف الركاب",
          BagCount: "عدد الحقائب",
          PassengerCount: "عدد الركاب",
          coupon: "قسيمة",
          Description: "ملحوظات",
          preBookingNow: "الحجز المسبق الآن",
          Cash: "نقدي",
        },

        sendParcel: {
          SourceCity: "موقع المرسل",
          DestinationCity: "موقع المستلم",
          SenderPhone: "رقم هاتف المرسل",
          SenderName: "اسم المرسل",
          SenderId: "هوية المرسل",
          ReceiverPhone: "رقم هاتف المستلم",
          ReceiverName: "اسم المستلم",
          ReceiverId: "هوية المستلم",
          Notes: "ملاحظات",
          preBookingNow: "إرسال الطرد الآن",
        },

        //bookTour page
        bookTour: {
          startFrom: "مكان البدء",
          startDate: "تاريخ البدء",
          paymentType: "نوع الدفع",
        },

        //TourismTour Page
        tourismTour: {
          tourismTitle: "الجولات السياحية",
          tourismTitleErr: "الجولات السياحية غير متوفرة حاليًا",
          tourismTitleErr2: "نحن نعمل حالياً على تطوير وتحسين خدمة الجولات السياحية لتقديم تجربة مميزة تلبي تطلعاتكم.",
          tourismTitleErr3: "سيتم إتاحة الخدمة قريباً، تابعونا لمعرفة آخر التحديثات.",
          rehlaTourism: "رحلة",
        },

        //AboutUs Page
        AboutUspage: {
          stayTuned: "ترقبوا الأخبار الجديدة إنهم يأتون مع العرض",
          featureIntegration: "تكامل الميزات",
          multipleDiscussions: "مناقشات متعددة",
          GetStarted: "ابدأ",

          OurRehla1: "ملكنا",
          OurRehla2: "رحلة",
          OurRehla3: "فريق",

          Gallery: "معرض",

          SeeAll: "رؤية الكل",
          Branding: "العلامة التجارية",
          Designing: "تصميم",
          Photography: "التصوير الفوتوغرافي",
          Development: "تطوير",

          availablDevices: "رحلة متاحة لجميع الأجهزة",
          avaiDes:
            "استمتع بسفر ذكي، اقتصادي، وآمن بين المدن",
        },

        //ContactUsPage
        contactUspage: {
          nameplaceholder: "أدخل اسمك",
          emailplaceholder: "أدخل عنوان بريدك الإلكتروني",
          messageplaceholder: "اكتب رسالتك",
          submit: "أرسل رسالة",
        },

        //Footer page
        footer: {
          description1: " عبارة عن مشاركة في الرحلات ومشاركة الرحلات",
          description2: "الخدمة التي تربط بين الركاب",
          description3: "وأصحاب المركبات المتوجهين إلى",
          description4: "نفس الوجهة",

          sitemap: "خريطة الموقع",
          usefulLinks: "روابط مفيدة",
          contactInfo: "معلومات الاتصال",
          address1: "ميدان الإتقان، طريق المدينة المنورة - ص.ب. 23215 ",
          address2: "المملكة العربية السعودية",
          phone: "920011455",
          email: "care@rehlacar.com",
          home: "الرئيسية",
          services: "خدمات",
          prebooking: "رحلات الحجز المسبق",
          tourism: "جولات سياحية",
          news: "أخبار",
          terms: "شروط الاستخدام",
          privacy: "سياسة الخصوصية",
          faq: "سؤال متكرر",
          copyright: "رحلة جميع الحقوق محفوظة",
        },
        //Terms of Use Page
        termsOfUse: {
          terms: "الشروط والأحكام",
          Title1: "مقدمة",
          Discription1: "يرجى قراءة هذه الشروط والأحكام بعناية قبل استخدام تطبيق رحلة أو أي من خدماته.",
          List1: [
            "يُعد إتمامك لعملية التسجيل أو استمرارك في استخدام التطبيق موافقة صريحة منك على الالتزام بهذه الشروط والأحكام، والتي تمنحك ترخيصًا محدودًا لاستخدام التطبيق والاستفادة من خدماته.",
            "هذا الترخيص مخصص للاستخدام الشخصي فقط، ولا يخولك بيع التطبيق أو أي من ميزاته أو التقنيات المرتبطة به.",
            "في حال عدم موافقتك على أي من هذه الشروط والأحكام، يجب عليك الامتناع عن استخدام التطبيق أو أي من خدماته.",
            "تُعتبر موافقتك على هذه الشروط التزامًا قانونيًا ملزمًا بينك وبين تطبيق رحلة فيما يتعلق باستخدامك للخدمات المقدمة.",
            "يحق لإدارة التطبيق إيقاف أو تعليق خدمات رحلة أو منعك من الوصول إلى التطبيق أو أي جزء منه في أي وقت ولأي سبب دون إشعار مسبق.",
            "يحق لإدارة التطبيق تعديل هذه الشروط والأحكام من وقت لآخر وفقًا لما تراه مناسبًا، وتصبح التعديلات سارية فور نشرها على التطبيق.",
            "قد يقوم تطبيق رحلة بالإفصاح عن بعض المعلومات، بما في ذلك بيانات الاتصال الخاصة بك، إلى الجهات المختصة أو شركات التأمين عند الحاجة لتسوية الشكاوى أو النزاعات.",
            "يشمل ذلك الحالات التي تنشأ فيها نزاعات أو حوادث بينك وبين مزود خدمة خارجي، حيث تكون هذه المعلومات ضرورية لحل النزاع أو الشكوى."
          ],
          Title2: "التعريفات",
          Discription2: "جميع المصطلحات الواردة في هذه الشروط والأحكام يكون لها المعاني الموضحة أدناه:",
          List2: [
            "شركة ترحال المدن للنقل البري (\"نحن\" أو \"لدينا\" أو \"لنا\" أو \"بنا\"): تعني تطبيق رحلة، وتلتزم بحماية واحترام الخصوصية.",
            "الحساب: يشير إلى حساب المستخدم على تطبيق رحلة والذي يتيح له استخدام التطبيق.",
            "التطبيق: يشير إلى تطبيق رحلة على الهاتف المحمول وأي تحديثات يتم إصدارها من وقت لآخر.",
            "بيانات التسجيل: تشمل الاسم، رقم الهاتف، البريد الإلكتروني، العمر، وأي معلومات أخرى قد يطلبها التطبيق أثناء التسجيل أو لاحقًا.",
            "المستخدم: هو الشخص الذي قام بإنشاء حساب لاستخدام التطبيق. وتشير \"أنت\" أو \"لك\" أو \"نفسك\" إلى المستخدم.",
            "سعر الرحلة: هو السعر المقترح لخدمة النقل والذي يفوض فيه مزود الخدمة تطبيق رحلة بتحديده.",
            "تطبيق رحلة: يشمل التطبيق والمنصة الإلكترونية معًا.",
            "أيام العمل: تعني أيام العمل الرسمية من الأحد إلى الخميس.",
            "الرصيد: هو القيمة المخزنة في محفظة المستخدم داخل التطبيق، والتي يمكن استخدامها لدفع تكاليف الحجز عبر القنوات المتاحة.",
            "مزود الخدمة: هو السائق أو الناقل أو المرشد السياحي الذي يقدم خدمة النقل.",
            "طالب الخدمة: هو المسافر أو الراكب أو السائح أو طالب نقل الطرود، ويشمل أي شخص يقوم بالحجز ويتم تأكيده من قبل مزود الخدمة.",
            "الضرر: يشمل الإصابة الجسدية، الفقد، الفقد الجزئي، الوفاة، السرقة، أو أي ضرر آخر قد يلحق بالمسافر.",
            "مكان الانطلاق: هو الموقع الذي يحدده طالب الخدمة لبدء الرحلة.",
            "مكان الوصول (الوجهة): هو الموقع الذي يحدده طالب الخدمة لإنهاء الرحلة.",
            "موعد المغادرة: هو الوقت الذي حدده طالب الخدمة لبدء الرحلة."
          ],
          Title3: "الترخيص",
          Discription3: "تمثل موافقتك على هذه الشروط والأحكام تعهدًا رسميًا بينك وبين تطبيق رحلة.",
          List3: [
            "وعليه تمنحك رحلة، عند امتثالك لهذه الشروط، ترخيصًا محدودًا غير حصري، لا يمكن ترخيصه من الباطن ولا يمكن نقله إلى أي طرف آخر.",
            "وذلك من أجل الوصول إلى تطبيق رحلة واستخدامه على جهازك الشخصي.",
            "والوصول إلى أي من المحتوى أو المعلومات أو المواد ذات الصلة والتي تتوفر من خلال تطبيق رحلة واستخدامها.",
            "وفي جميع الحالات يكون الاستخدام لتطبيق رحلة استخدامًا شخصيًا فحسب وغير تجاري.",
            "وتحتفظ رحلة ومانحو الترخيص التابعون لها بأي حقوق غير موضحة صراحة في شروط الاستخدام."
          ],
          Title4: "حقوق الملكية الفكرية",
          Discription4: "",
          List4: [
            "تعود حقوق ملكية تطبيق رحلة لمؤسسة ترحال المدن للنقل البري ومن يقوم بتشغيله بالنيابة عنها.",
            "تكون جميع الواجهات البصرية والرسوم البيانية والتصاميم والمعلومات والمحتوى وكود الحاسوب الخاص بالموقع والبرمجيات المستخدمة والخدمات بالإضافة إلى جميع العناصر الأخرى للتطبيق وجميع حقوق الملكية الفكرية وحقوق الملكية المتعلقة بهذه العناصر مملوكة بشكل حصري وخالص لتطبيق رحلة أو الجهات المرخص لها من قبل تطبيق رحلة.",
            "تكون جميع العلامات التجارية وعلامات الخدمات والأسماء التجارية مملوكة من قبلها والشركات التابعة لها وشركائها في توفير خدمات السفر أو غيرهم من المزودين.",
            "ولا تمنحك هذه الاتفاقية ولا استخدامك لمنصة رحلة أي حقوق في أو تتعلق بمنصة رحلة باستثناء الترخيص الممنوح بهذا الاتفاق.",
            "كما لا يجوز الاستخدام أو الإشارة بأي صورة من الصور إلى أسماء تطبيق رحلة أو شعاراتها أو أسماء منتجاتها أو خدماتها أو علاماتها التجارية أو علامات خدماتها أو أسماء المرخص لهم التابعين لها."
          ],
          Title5: "الثقة والمصداقية",
          Discription5: "",
          List5: [
            "يقدم هذا التطبيق الثقة والمصداقية لمن يستخدمه وذلك لأنه يستوفي جميع الوثائق والمعلومات التي تفرضها وزارة النقل أو بوابة علم عن طريق نظام حجز وتوزيع طلبات خدمة الأجرة والتي يتم ربطها وتكاملها مع النظام التقني في الهيئة العامة للنقل (منصة وصل) حيث يتم التحقق منها كما في باقي التطبيقات الأخرى، وذلك لتوفير معلومات كاملة عن خط سير المركبة، اسم السائق، رقم اللوحة.",
            "وتزداد هذه الثقة والمصداقية مع ارتفاع تقييم وتعليقات المسافرين وأصحاب المركبات والتي تعطي انطباعًا عن الشخص الذي ستتعامل معه على أنه شخص موثوق به وآمن.",
            "وفي حال وصول أي شكوى أو بلاغ يتم التحقق من ذلك عن طريق استخدام وسائل التواصل التي تم التسجيل بها في حساب العميل والتواصل معه للتحقق من الشكوى وبعدها يتم اتخاذ الإجراء المناسب، بالإضافة إلى بذل أقصى جهد ممكن في إمكانية استعادة أي مفقودات."
          ],
          Title6: "حسابات المستخدمين",
          Discription6: "",
          List6: [
            "يقوم هذا التطبيق على تقديم خدمة الوساطة بين مزود الخدمة وطالب الخدمة الذي يرغب في التنقل.",
            "ومن أجل استخدام معظم خدمات تطبيق رحلة، يتعين عليك التسجيل للحصول على حساب مستخدم شخصي فعال والمحافظة عليه.",
            "وبالتالي أنت تقر بأنك تبلغ من العمر 18 عامًا على الأقل ولا تزيد عن 65 عامًا حتى يتسنى لك الحصول على حساب لدينا.",
            "ويتطلب تسجيل الحساب تقديم بعض المعلومات الشخصية إلى تطبيق رحلة، مثل اسمك وعنوانك ورقم هاتفك الجوال وجنسك وعمرك ورقم الهوية الوطنية.",
            "وتوافق من جانبك على تدوين معلومات دقيقة وكاملة وحديثة في حسابك الخاص والمحافظة عليها.",
            "قد ينجم عن عدم التزامك بالمحافظة على دقة وصحة معلومات حسابك عدم تمكنك من الوصول إلى منصة رحلة واستخدامها، بما في ذلك قدرتك على طلب الوصول إلى معلوماتك الشخصية أو الاشتراك في إنشاء أو طلب رحلة.",
            "وتتحمل المسؤولية عن سائر الأنشطة التي تجري في حسابك، وتوافق على الحفاظ على سلامة وأمان اسم المستخدم وكلمة المرور الخاصين بحسابك وسريتهما في جميع الأوقات.",
            "وبالتالي موافقتك على هذه الشروط يتيح للتطبيق إمكانية مشاركة بعض المعلومات عنك مع أعضاء آخرين من خلال ملفك الشخصي العام أو أثناء عملية الحجز (على سبيل المثال: إظهار التقييمات التي تلقيتها والتي كتبتها عن الآخرين وكذلك رقم هاتفك لمزودي أو طالبي الخدمة الذين سيقومون بطلب أو تنفيذ الرحلات لكي يكون التواصل أكثر سهولة ويسر).",
            "بالنسبة للمسافر (الراكب - طالب الخدمة) فإنه على علم وموافقة بأن هذا النوع من التطبيقات يقوم على الوساطة بين خدمات النقل التي يقدمها السائقون وبين العملاء طالبي الخدمة، حيث يربط تطبيق رحلة طالب الخدمة ومزود الخدمة بالخدمات التالية: توصيل المسافر من مكان إلى مكان آخر سواء كانت الخدمة استقبال وتوديع من المطارات التي يتواجد فيها تطبيق رحلة بشكل نظامي، أو جولة سياحية مع مرشد سياحي مرخص، أو نقل طرد يخص طالب الخدمة من مكان إلى مكان، أو رحلة سفرية بين مدينتين.",
            "كما يوافق المسافر على دفع قيمة الرحلة التي يحددها التطبيق كاملة لمزود الخدمة (الكابتن).",
            "وكجزء من نظام التقييم الخاص بنا، سيتم نشر التقييمات والتعليقات التي تكتبها أو تتلقاها على المنصة والتي تشمل اسمك المختصر وصورتك الشخصية والتي ستكون مرئية للآخرين.",
            "إذا كنت منافسًا أو تقدم خدمة منافسة لتطبيق رحلة والخدمات التي يقدمها، وقمت بالتسجيل والموافقة على استخدام التطبيق وأنت تتمتع بكامل حريتك وقدرتك على التسجيل، فتعتبر موافقتك على هذه الشروط ملغية ولا يسمح لك بالاستمرار باستخدام تطبيق رحلة أو أي خدمة يقدمها التطبيق، ويحق لنا الرفع للجهات ذات العلاقة لاستخدامك غير الشرعي وغير القانوني وغير المرخص لتطبيق رحلة، وسوف تتحمل كل ما يترتب عليه من تكاليف وأتعاب المحاماة ضدك.",
            "لا يحق لك امتلاك أكثر من حساب واحد ما لم تسمح رحلة بخلاف ذلك.",
            "كذلك أنت تقر بأنه لم يسبق أن تم إيقاف حسابك أو منعك من التسجيل لأي أسباب تمنعك من استخدام خدمات تطبيق رحلة."
          ],
          Title7: "التعهدات وضمانات المستخدمين وسلوكهم",
          Discription7: "بموجب موافقتك على هذه الشروط والاحكام: فانت تقر وتتعهد بالامتثال لجميع الانظمة واللوائح التي تشترطها الجهات الرسمية بالمملكة العربية السعودية مثل الهيئة العامة للنقل. بحيث ان لا يقل عمر المستخدم عن 18 عاما ولا يزيد عن 65 عام بالنسبة لمزود الخدمة، وان يستخدمه الأفراد البالغين الراشدين المؤهلين قانونيا. ولا يجوز لك السماح للغير باستخدام حسابك، ولا يجوز لك التنازل عن حسابك أو نقل ملكيته إلى أي شخص أو كيان آخر. وتوافق من جانبك على الالتزام بجميع القوانين المعمول بها عند استخدامك لتطبيق رحلة، ولا يحق لك استخدام تطبيق رحلة إلا لأغراض قانونية. لا يسمح لك بنسخ المحتوى او تصوير الشاشات الداخلية للاستخدام غير المتفق عليه.",

          Title8: "طريقة التسجيل واستخدام التطبيق",
          Discription8: "استخدام هذا التطبيق يتطلب التسجيل لأصحاب المركبات (الكباتن) وتسجيل المركبات والمسافرين الذين تتوفر لديهم المتطلبات الأساسية للاشتراك بالخدمة حسب الاشتراطات اللازمة من الهيئة العامة للنقل والتي تستوجب الارتباط بالنظام التقني المعتمد في هيئة النقل العام (منصة وصل). وقد تم تقسيم متطلبات التسجيل إلى أجزاء مختلفة كما يلي:",

          Title8_1: "أولاً: الكابتن (صاحب المركبة – مزود الخدمة)",
          Discription8_1: "هو الشخص الذي لديه مركبة تخصه ويرغب بالعمل بها في التطبيقات المرخصة من هيئة النقل دون التزام او ارتباط بوقت محدد، ويستقبل الطلبات من المسافرين مقابل مبلغ مالي. ويلتزم بالاشتراطات النظامية التالية:",
          List8_1: [
            "أن يكون سعودي الجنسية أو ابن / ابنة مواطنة.",
            "أن يكون حاصلاً على رخصة قيادة سارية المفعول.",
            "اجتياز الفحص الطبي المحدد من قبل الهيئة.",
            "أن يكون حاصلاً على شهادة خلوّ من السوابق.",
            "اجتياز الدورة التدريبية الخاصة بالتعامل مع التطبيق.",
            "وجود رخصة قيادة سارية المفعول.",
            "أن يكون هو السائق الفعلي للمركبة أو المفوض عليها.",
            "أن يتملك جهاز جوال محمل به التطبيق مع رقم محلي وخاصية الإنترنت.",
            "ألا يقل العمر عن 18 عام ولا يزيد عن 65 عام."
          ],

          Title8_2: "ثانياً: المركبة",
          Discription8_2: "يجب أن تتوفر في المركبة المستخدمة في هذا التطبيق بعض الشروط والمواصفات التي تتطلبها الجهات الرسمية بالمملكة العربية السعودية وهي:",
          List8_2: [
            "أن تكون السيارة وفق المواصفات والتجهيزات الفنية المعتمدة من قبل الرئيس.",
            "التأمين على السيارة بما يغطي المسؤولية المدنية تجاه الغير ويشمل الركاب طيلة مدة التشغيل.",
            "أن تكون السيارة خاضعة للفحص الفني الدوري المعتمد وفق أحكام نظام المرور ولائحته التنفيذية.",
            "أن تكون السيارة الخاصة مملوكة لسائق التوجيه بشكل مباشر أو مموّلة من قبل إحدى الجهات التمويلية المعتمدة.",
            "رخصة سير سارية المفعول تتضمن ملكية السائق للمركبة أو تفويض بالقيادة للسيارات المؤجرة.",
            "ألا يزيد العمر التشغيلي عن خمس سنوات من بداية شهر يناير لسنة الصنع.",
            "أن لا تقل المسافة بين مركزي المحورين (قاعدة العجلات) عن 2.75م ويستثنى من ذلك المركبات الكهربائية والهجين.",
            "أن تكون السيارة في حالة جيدة وخالية من الصدمات الظاهرة والعلامات التجارية والإعلانات.",
            "أن تتوفر في المركبة: إطار احتياطي، وحقيبة الإسعافات الأولية، وطفاية الحريق، والمثلث العاكس، والعدة اللازمة لتغيير الإطارات وأن تكون بحالة فنية سليمة.",
            "عدم تظليل المركبات قبل الموافقة على إدخالها في الخدمة وخلال فترة تقديم الخدمة."
          ],

          Title8_3: "ثالثاً: طالب الخدمة",
          Discription8_3: "وهو الشخص الذي لديه الرغبة والحاجة للتنقل من مكان الى مكان محدد أو السفر من مدينة الى مدينة. وللتسجيل كعميل في تطبيق رحلة يجب أن تتوفر لديك المتطلبات التالية:",
          List8_3: [
            "جهاز هاتف للتواصل.",
            "هوية وطنية أو إقامة سارية المفعول.",
            "جهاز جوال يحمل هذا التطبيق مع خاصية الاتصال بالإنترنت."
          ],

          Title9: "الأسعار والرسوم والمدفوعات والضرائب",
          Discription9: "بصفتك مزود خدمة على تطبيق رحلة، فإنك توافق على تفويض رحلة في تحديد السعر، وعلى سداد أي مبالغ مستحقة على حسابك نظير الاستفادة من خدمة الوساطة التي قدمتها لك شركة رحلة عبر التطبيق. وفي حالة عدم توفر رصيد كافٍ ستكون المحفظة بالسالب (وهو الحد الأدنى من المديونية) المسموح به قبل إيقاف الحساب. وتكون جميع مصاريف ورسوم استخدام منصة رحلة مستحقة على الفور، وسيتم تسهيل الدفع من خلال طرق الدفع المتوفرة في التطبيق (شحن المحفظة). وتحتفظ منصة رحلة بالحق في فرض الرسوم أو إلغائها أو تعديلها في أي وقت وفقاً لتقدير تطبيق رحلة المنفرد.",

          Title10: "آلية صرف المستحقات والتسعير وحساب التكلفة",
          Discription10: "بموافقتك على هذه الشروط والاحكام كمزود أو طالب خدمة فانك توافق على أن يقوم تطبيق رحلة باقتراح سعر الرحلة بناء على المعطيات المقدمة من طالب الخدمة (حساب الكيلومتر من نقطة الانطلاق الى نقطة الوصول – مدة الرحلة – وقت الانتظار – وقت الذروة - فئة المركبة – أجرة فتح الباب – رسوم هيئة النقل (0.50) وقيمة الضريبة). ولطالب الخدمة كامل الحرية في قبول أو رفض سعر الرحلة الظاهر.",

          Title10_1: "1- رسوم خدمة الوساطة",
          Discription10_1: "يتم تحصيل رسوم خدمة الوساطة (عمولة التطبيق) من محفظة مزود الخدمة (الكابتن) كنسبة من قيمة المشوار وذلك مقابل استخدام التطبيق والوساطة بين مزودي الخدمة وطالبي الخدمة لإتمام عملية الحجز وضمان سلامة وموثوقية الحجوزات وإكمال إجراءات الحجز وتحويل النقود عن طريق التطبيق.",

          Title10_2: "2- التكلفة الحكومية",
          Discription10_2: "حسب اشتراطات هيئة النقل بضرورة الربط مع منصة وصل وتقديم خدماتها، فإنه يتم تحصيل قيمة 0.50 ريال سعودي (خمسون هللة) كرسوم تكلفة الخدمة المقدمة بموجب الاتفاقية مع منصة وصل على أي رحلة يتم إنشاؤها عبر التطبيق، والتي تحتسب من ضمن تكاليف التشغيل على تطبيق رحلة.",

          Title10_3: "3- ضريبة القيمة المضافة VAT",
          Discription10_3: "وفقاً لتشريعات ضريبة القيمة المضافة المعمول بها في المملكة العربية السعودية فإن خدمة الوساطة من ضمن الأنشطة الخاضعة لضريبة القيمة المضافة بالنسبة الأساسية 15%، وتُفرض ضريبة القيمة المضافة على قيمة عمولة تطبيق رحلة.",

          Title11: "آلية الدفع وسحب الرصيد والتعويض واسترجاع المستحقات المالية",

          Discription11: "يوفر في التطبيق عدة طرق للدفع تلبي احتياجات كل من طالب الخدمة ومزود الخدمة، مع الأخذ في الاعتبار معايير الأمان والمصداقية وحماية البيانات. وتتم العمليات المالية في التطبيق بشكل أساسي من خلال المحفظة الإلكترونية، حيث تُستخدم لإدارة المدفوعات الخاصة بالرحلات وخصم المستحقات. ويعكس رصيد المحفظة القيمة النقدية المتاحة، مع وجود سجل تفصيلي يُوثّق جميع العمليات، بحيث يتم خصم المبلغ المستحق من المحفظة عند اكتمال الحجز. كما يتيح التطبيق لمزود الخدمة (السائق) سحب أرباحه من تنفيذ الرحلات وتحويلها إلى حسابه الجاري في أي وقت وبكل سهولة عن طريق تقديم طلب سحب من خلال المحفظة بالتطبيق. ويتم تحويل طلبات سحب أرباح مزودي الخدمة على 4 فترات زمنية في اليوم الواحد، ولا يترتب على طلب سحب المستحقات أي رسوم مالية. وعملية تحويل المستحقات تبدأ من وقت طلب السحب إلى 3 أيام عمل كحد أقصى، بشرط ألا يقل الرصيد المطلوب سحبه عن 50 ريال. عند إيداع أو شحن المحفظة بمبلغ معين، وتمت عملية سحب المبلغ مع عدم وجود أي عملية على الحساب مثل طلب رحلة أو إنشاء رحلة ولم يستفد المستخدم من خدمات التطبيق، فإن عملية استرجاع المبلغ تكون على نفس البطاقة التي تم الدفع منها، ويكون المبلغ خاضعًا لأي خصومات مثل العمولات البنكية أو أي رسوم تتحملها الشركة نتيجة التحويلات البنكية أو الضريبية. كما قد تستغرق عملية الاسترجاع مدة 15 يوم عمل من تاريخ رفع طلب الاسترجاع.",

          PaymentMethodsTitle: "طرق الدفع المتاحة:",

          List11_1: [
            "الدفع النقدي المباشر من طالب الخدمة إلى مزود الخدمة.",
            "شحن المحفظة بشراء بطاقة الدفع المسبق الخاصة بالتطبيق.",
            "التحويل البنكي الإلكتروني أو بطاقة الفيزا لشحن رصيد المحفظة.",
            "الإيداع في حساب التطبيق واستلام رسالة بكود الشحن على الجوال.",
            "استخدام العروض الترويجية لشحن المحفظة."
          ],

          Title12: "شروط الحجز",
          Discription12: "عند قيام المسافر بأي حجز، فإنه يُوافق ومن ينوب عنه أنه قرأ شروط الحجز هذه وأنه يوافق على الالتزام بها ولديه الصلاحية التي تُخوله لذلك، وأنه يُوافق على استخدامنا للمعلومات بما يتوافق مع سياسة الخصوصية الخاصة بنا. يجب على المسافر قبول جميع الشروط قبل عملية الدفع ليتم تأكيد الحجز. جميع المسافرين يجب أن يكونوا على دراية وفهم كامل بالشروط أثناء عملية الحجز. ولن تتم عملية الحجز بنجاح في حال عدم دفع المبلغ بشكلٍ كامل عن طريق المحفظة إلا في حالة اختيار الدفع نقداً.",

          Title13: "سياسة إلغاء الحجز",
          Discription13: "في حاله إلغاء الحجز بعد دفع الرسوم في رحلة معينة من قبل السائق أو الراكب بعد تأكيد الحجز يخضع للشروط التالية:",

          Title13_1: "في حالة إلغاء الرحلة أو تأخر الكابتن عن الحضور",
          List13_1: [
            "يسترد طالب الخدمة كامل المبلغ المدفوع عند إلغاء الرحلة من قبل مزود الخدمة قبل الوقت المحدد مع ضرورة التواصل معه لإثبات عدم الاستجابة للاتصال وإبلاغنا بذلك عبر التطبيق خلال 24 ساعة.",
            "يسترد طالب الخدمة كامل المبلغ المدفوع في حال تعطلت المركبة أثناء الرحلة من مزود الخدمة أو عن طريق الإيداع في محفظة طالب الخدمة."
          ],

          Title13_2: "في حالة إلغاء الرحلة أو تأخر المسافر عن الحضور",
          List13_2: [
            "إلغاء قبل 12 ساعة من الموعد المقرر للمغادرة: يحق لطالب الخدمة استرداد كامل تكلفة الرحلة إذا كان الدفع عن طريق المحفظة.",
            "إلغاء خلال 12 ساعة وأكثر من 3 ساعات من الموعد: يتحمل طالب الخدمة نصف تكلفة الرحلة ويتم تحويل الباقي إلى محفظة مزود الخدمة.",
            "إلغاء قبل الموعد بثلاث ساعات أو أقل، أو عدم الوصول لمكان الانطلاق قبل 15 دقيقة: لا يتم إرجاع أي مبلغ لطالب الخدمة ويستحق مزود الخدمة كامل السعر.",
            "إلغاء الحجز بعد وصول مزود الخدمة لاختلاف البيانات الظاهرة في التطبيق مع المركبة والسائق: يتم تعويض الراكب قيمة الرحلة وتُرتَّب غرامة على حساب مزود الخدمة.",
            "إلغاء الرحلة بسبب عدم نظافة المركبة مع وجود ما يثبت ذلك: يتم إرسال سيارة بديلة للراكب.",
            "إلغاء الرحلة في حال تأخر الرحلة عن الوقت المحدد بالتطبيق: يتم تعويض طالب الخدمة بنصف قيمة الرحلة."
          ],

          Title13_3: "في حالة ألغى تطبيق رحلة الحجز الخاص بك",
          List13_3: [
            "قد نلغي الحجز الخاص بك في أي وقت بأثرٍ فوري في حالة مخالفتك أحد الشروط الجوهرية أو عدم سدادك جميع المدفوعات المطلوبة على المحفظة في الوقت المحدد.",
            "قد نضطر في حالات استثنائية لإلغاء الحجز الخاص بك نظراً لظروف قوة قاهرة أو تعطل أحد مزودي الخدمة للتطبيق أو لإجراء بعض التحديثات أو التعديلات على التطبيق."
          ],

          Title14: "آلية الرقابة على مزودي الخدمة والمركبات",
          List14: [
            "عند التسجيل كمزود خدمة يجب عليك تقديم وثائق رسمية مثل الهوية الوطنية ورخصة القيادة سارية المفعول واستمارة السيارة والفحص الدوري وأي وثائق أخرى يتطلبها إكمال التسجيل.",
            "يتم التأكد من أهلية المركبة عن طريق فحص المركبة عبر شركة فاحص أو إرسال مقاطع فيديو أو صور تثبت سلامة المركبة.",
            "يقوم تطبيق رحلة بعمل فحص عشوائي بشكل دوري لتقييم نظافة المركبات والتأكد من أن السائقين هم من يقومون بعمل الرحلات مع الأخذ بالاعتبار تقييمات العملاء أو طالبي الخدمة.",
            "يتم التحقق من المركبات في المطارات ومحطات القطار عن طريق مشرف خدمة العملاء (المرحِّل) المتواجدون هناك.",
            "يؤخذ في الاعتبار أي تنظيمات صادرة من قبل الهيئة بهذا الشأن."
          ],

          Title15: "مصاريف الإصلاح أو التنظيف",
          Discription15: "لا يتحمل تطبيق رحلة أو المسافرون أي مصاريف تخص عملية الإصلاح أو التنظيف نتيجة تعرض المركبة للأتربة والاتساخ أو العطل، مع ضرورة أن تكون المركبة نظيفة وفي حالة جيدة حتى لا يؤثر ذلك على تقييم المركبة أو الكابتن.",

          Title16: "الأنشطة المحظورة",
          Discription16: "فيما يتعلق باستخدامك لمنصة رحلة ومشاركتك في الخدمات، فإنك توافق على تجنب القيام بالمحظورات التالية، وفي حال ثبوت ذلك فإنك ستتحمل وحدك مسؤولية الامتثال لكافة القوانين واللوائح وقد يتعرض حسابك للإيقاف والحظر والمسألة القانونية:",
          List16: [
            "انتحال شخصية أي شخص أو كيان آخر كمسافر أو كابتن.",
            "نقل أو بيع حساب المستخدم وكلمة المرور والتعريف الخاص بك إلى أي طرف آخر.",
            "مطاردة أو تهديد أو مضايقة أي شخص بما فيهم المستخدمون الآخرون الذين يستفيدون من الخدمة.",
            "حمل أي أسلحة أو انتهاك أي قانون أو تشريع أو قاعدة أو تصريح أو مرسوم أو لائحة.",
            "التدخل في الخدمات أو منصة رحلة أو الخوادم أو الشبكات المتصلة أو تعطيلها.",
            "إرسال معلومات أو التفاعل على منصة رحلة بطريقة احتيالية أو غير دقيقة أو مضللة أو تشهيرية أو افترائية أو مسيئة.",
            "تعاطي أو نقل المخدرات أو المواد الكحولية وأي نوع من الأنواع المحظورة حسب قوانين المملكة.",
            "استخدام منصة رحلة بأي طريقة تنتهك حقوق الملكية الفكرية أو حقوق النشر أو البراءة أو العلامة التجارية.",
            "نشر أو إرسال أي تعليمات برمجية ضارة أو ملفات أو برامج مصممة لعرقلة أو تلف أو تدمير أي برنامج أو جهاز.",
            "تزوير العناوين الرئيسية أو التلاعب بالمعرفات من أجل إخفاء أصل أي معلومات مرسلة عبر منصة رحلة.",
            "تعديل أو تكييف أو ترجمة أو فك شفرة أو تفريغ أي جزء من منصة رحلة أو البرامج المستخدمة فيها.",
            "تأجير أو استئجار أو إقراض أو بيع أو إعادة توزيع أو استصدار ترخيص لمنصة رحلة أو الوصول إلى أي جزء منها.",
            "استخدام أي روبوت أو جهاز أو عملية تلقائية لاسترداد البيانات أو فهرستها أو حذفها أو استخراجها من منصة رحلة.",
            "ممارسة التمييز ضد أي شخص أو مضايقته على أساس العرق أو الأصل القومي أو الدين أو الجنس أو الإعاقة أو السن.",
            "يمنع نقل الحيوانات أو الطيور عبر أي رحلة بشكل مباشر أو غير مباشر.",
            "السفر مع إعاقة أو مشكلة طبية دون الحصول على موافقة مُسبقة من الكابتن قبل إجراء عملية الحجز."
          ],

          Title17: "الإعاقات والمشاكل الطبية",
          Discription17: "إذا كنت تُعاني أنت أو أي فرد من أفراد جماعتك من مشكلة طبية أو إعاقة قد تُؤثر على رحلتك، فيُرجى إخبار الكابتن بها عند القيام بالحجز في خانة (تكلم عن نفسك). في أي حال من الأحوال، يجب عليك سرد التفاصيل كاملةً كتابةً في وقت القيام بالحجز. ومن حق الكابتن قبول الحجز أو رفضه وتحمُّل تبعات القبول عندما يعلم بهذه التفاصيل.",

          Title18: "إخلاء المسؤولية",
          Discription18: "يتم توفير منصة رحلة كما هي متوفرة حالياً. وتخلي منصة رحلة مسؤوليتها عن جميع الإقرارات والضمانات، سواء أكانت صريحة أم ضمنية أم قانونية، بما في ذلك الضمانات الضمنية لصلاحية العرض في السوق والملاءمة لغرض معين. لا تضمن منصة رحلة والشركات التابعة لها جودة أو ملاءمة أو سلامة أو قدرة السائق. إن منصة رحلة وشركاتها التابعة غير مسؤولة عن سلوك أي مستخدم أو سائق أو أي طرف ثالث آخر. مالك السيارة هو المسؤول وحده عن تعويض كافة الأضرار التي قد تصيب الغير أثناء تقديم الخدمة أو بسببها. ولا يتعين علينا توفير تأمين الأمتعة الشخصية بما فيها خسارة الأمتعة الشخصية نتيجة السرقة أو نسيانها في السيارة.",

          Title19: "تقييد المسؤولية",
          Discription19: "لن تتحمل منصة رحلة وفروعها وشركاؤها المسؤولية عن أي أضرار غير مباشرة أو عرضية أو خاصة أو طارئة أو عقابية أو تبعية، بما في ذلك الأرباح الفائتة أو البيانات المفقودة أو الإصابات الشخصية. لن تكون منصة رحلة مسؤولة عن أي أضرار أو مسؤوليات أو خسائر تنشأ عن:",
          List19: [
            "استخدامك أو اعتمادك على منصة رحلة أو الخدمات أو عدم قدرتك على الوصول إليها.",
            "أي معاملة أو علاقة بينك وبين أي سائق أو أي طرف ثالث آخر.",
            "التأخر أو الفشل في أداء الخدمات الناجم عن أسباب خارج سيطرتنا المعقولة.",
            "أي خدمة مقدمة إليك من قِبل السائق بخلاف ما ورد صراحة في هذه الاتفاقية.",
            "لا يحق تمكين السائق المسجل في منصة وصل لغيره من قيادة نفس المركبة."
          ],

          Title20: "التعويض",
          Discription20: "عن حدوث أية إصابات أو أمراض أو حالات وفاة أو خسائر أو أضرار أو مصروفات أو نفقات أو مطالبات أخرى أياً كانت، فلن نتحمل أي مسؤولية أو نُسدِّد أي تعويضات حيث دورنا الوساطة بين المسافر والكابتن. ويتعين عليك تعويض منصة رحلة وفروعها والشركاء الآخرين وموظفيهم ومديريهم ومسؤوليهم ووكلائهم ودفع الضرر عنهم ضد أي مطالبات أو طلبات أو خسائر أو التزامات أو مصاريف بما في ذلك أتعاب المحاماة الناشئة عن استخدامك لمنصة رحلة أو مخالفتك أو انتهاكك لهذه الاتفاقية.",

          Title21: "حل النزاع والأحكام العامة",
          Discription21: "لا يجوز لك التنازل عن حقوقك أو نقلها بموجب هذه الاتفاقية كليا أو جزئيا دون الحصول على موافقة خطية مسبقة من منصة رحلة. تشكل هذه الاتفاقية مجمل الاتفاق والتفاهم بين الأطراف يتعلق بموضوعها، وتنسخ وتحل محل جميع الاتفاقيات أو التعهدات السابقة أو القائمة ذات الصلة بهذا الموضوع. ولا يؤدي العقد المبرم بينك وبين منصة رحلة إلى إنشاء أي مشروع مشترك أو شراكة أو علاقة توظيف أو وكالة بينك وبين منصة رحلة أو أي سائق.",

          Title22: "تعديل الشروط والأحكام والحجوزات",
          Discription22: "يحق لتطبيق رحلة تعديل أو إضافة أي شروط من وقت لآخر في أي وقت دون الحاجة إلى تقديم إشعار بذلك. حيث يُطرح الإصدار أو التحديث الجديد من الشروط والأحكام على المنصة والتطبيق من جانبنا. وعند تحميلك التحديث أو الإصدار الجديد وعند استمرارك في استخدام التطبيق بعد هذه التعديلات يُعدّ بمثابة الموافقة والقبول لهذه التعديلات أو التغييرات بشكل تلقائي.",

          Title23: "الشكاوى",
          Discription23: "إذا رغبت في تقديم أي شكوى أو استعلام الرجاء التواصل مباشرة عبر الرابط المخصص للشكاوى والاستفسارات بالتطبيق (اتصل بنا) حيث هناك أكثر من قناة للتواصل مع العملاء تتناسب مع احتياجاتهم، ومنها خدمة المفقودات التي نسعى لبذل قصارى جهدنا في مساعدتك في الحصول عليها وتسهيل وتحديد آلية تسليم المفقودات لأصحابها بكل أمان وسهولة. حيث يتم اتخاذ إجراءات الشكاوى خلال 3 أيام عمل.",

          Title24: "اللغة",
          Discription24: "يعتمد هذا التطبيق على اللغة العربية كلغة أساسية للاستخدام والتحاكم، بالإضافة إلى اللغة الإنجليزية للاستخدام، كما سيتم إضافة بعض اللغات الأخرى إلى التطبيق حسب الاحتياج.",
          Title25: "لائحة المخالفات والجزاءات",
          Discription25: "تلتزم منصة رحلة بتطبيق لائحة المخالفات والجزاءات المعتمدة لتنظيم استخدام المنصة وضمان الالتزام بالأنظمة والتعليمات المعمول بها. يمكن الاطلاع على اللائحة الكاملة من خلال",
          DownloadViolations: "تحميل لائحة المخالفات والجزاءات (PDF)"
        },
        // Privacy Policy Page
        privacy: {
          Title1: "سياسة الخصوصية",
          Discription1: "نحن في تطبيق رحلة، المملوك لشركة ترحال المدن للنقل البري، نلتزم بحماية خصوصية مستخدمينا والحفاظ على سرية بياناتهم الشخصية. توضح هذه السياسة كيفية جمع المعلومات واستخدامها ومشاركتها وحمايتها عند استخدامك للتطبيق أو أي من خدماته.",

          Title2: "المعلومات التي نقوم بجمعها",
          Discription2: "عند تسجيلك واستخدامك لتطبيق رحلة، قد نقوم بجمع بعض البيانات الشخصية، بما في ذلك الاسم، رقم الهاتف، البريد الإلكتروني، العمر، رقم الهوية الوطنية أو الإقامة، بيانات الموقع الجغرافي، وبيانات الرحلات والحجوزات، بالإضافة إلى أي معلومات أخرى يتم طلبها بشكل نظامي لتقديم الخدمة.",

          Title3: "كيفية استخدام المعلومات",
          Discription3: "نستخدم البيانات التي نقوم بجمعها لتشغيل وتحسين خدمات تطبيق رحلة، وإدارة الحسابات، وتنفيذ الحجوزات، والتواصل مع المستخدمين، ومعالجة المدفوعات، وتحسين تجربة الاستخدام، والامتثال للمتطلبات النظامية والتنظيمية داخل المملكة العربية السعودية.",

          Title4: "مشاركة المعلومات مع الجهات الأخرى",
          Discription4: "قد نقوم بمشاركة بعض بياناتك مع الجهات الرسمية أو التنظيمية المختصة، مثل الهيئة العامة للنقل أو الجهات الحكومية ذات العلاقة، وكذلك مع شركات التأمين أو مزودي الخدمات، وذلك عند الحاجة النظامية أو لتسوية الشكاوى أو النزاعات أو الحوادث المرتبطة باستخدام التطبيق.",

          Title5: "حماية البيانات وأمن المعلومات",
          Discription5: "نلتزم باتخاذ التدابير التقنية والتنظيمية المناسبة لحماية بياناتك الشخصية من الوصول غير المصرح به أو التعديل أو الإفصاح أو الإتلاف، ونقوم بتحديث أنظمة الحماية بشكل دوري لضمان أعلى مستوى ممكن من الأمان.",

          Title6: "الاحتفاظ بالبيانات",
          Discription6: "نحتفظ ببياناتك الشخصية طالما كان ذلك ضروريًا لتحقيق الأغراض الموضحة في هذه السياسة، أو للامتثال للأنظمة واللوائح المعمول بها، أو لحل النزاعات وتنفيذ الاتفاقيات.",

          Title7: "حقوق المستخدم",
          Discription7: "يحق لك كمستخدم الوصول إلى بياناتك الشخصية أو طلب تعديلها أو تحديثها، كما يمكنك طلب إيقاف الحساب وفقًا للأنظمة المعمول بها. وقد يتطلب تنفيذ بعض الطلبات التحقق من هويتك حفاظًا على أمان المعلومات.",

          Title8: "بيانات الموقع الجغرافي",
          Discription8: "قد يستخدم تطبيق رحلة تقنيات تحديد الموقع الجغرافي وبيانات الاستخدام بهدف تحسين دقة الخدمة وتجربة المستخدم. يتم استخدام هذه البيانات للأغراض التشغيلية فقط.",

          Title9: "تعديلات سياسة الخصوصية",
          Discription9: "يحتفظ تطبيق رحلة بالحق في تعديل أو تحديث سياسة الخصوصية هذه من وقت لآخر. وسيتم نشر أي تحديثات على التطبيق أو الموقع، ويُعد استمرارك في استخدام الخدمات بعد التعديل موافقة صريحة على السياسة المحدثة.",

          Title10: "التواصل معنا",
          Discription10: "في حال وجود أي استفسار أو طلب بخصوص سياسة الخصوصية أو بياناتك الشخصية، يمكنك التواصل معنا عبر البريد الإلكتروني Care@rehlacar.com أو من خلال قنوات الدعم المعتمدة داخل التطبيق.",
          Title11: "حذف الحساب والبيانات",
          Discription11: "في حال رغبتك بحذف حسابك وجميع بياناتك من قاعدة البيانات، الرجاء الضغط ",
          DeleteLink: "هنا",
          enterPhone: "الرجاء إدخال رقم الجوال",
          enterOtp: "الرجاء إدخال الرمز المرسل إلى جوالك",
          next: "التالي",
          confirm: "تأكيد",
          deleteSuccess: "تم حذف حسابك بنجاح.",
          loading: "يرجى الانتظار...",
          phonePlaceholder: "512345678",
          phoneNotFound: "رقم الهاتف المدخل غير موجود",
          somethingWrong: "حدث خطأ غير متوقع، حاول مرة أخرى",
          deleteAccountDescription: "عند حذف حسابك، سيتم إزالة جميع بياناتك الشخصية من قاعدة البيانات الخاصة بنا، ولن تتمكن من استعادة الحساب أو البيانات بعد الحذف. يرجى التأكد من أنك ترغب في حذف حسابك قبل المتابعة.",


        },
      },
    },
  },
  lng: savedLanguage, // Use the saved language from localStorage
  fallbackLng: "en", // Fallback to English if language not found

  interpolation: {
    escapeValue: false, // React already escapes content
  },
});

// Listen for language changes and store them in localStorage
i18n.on("languageChanged", (lng) => {
  localStorage.setItem("i18nextLng", lng);
});

export default i18n;
